<template>
  <v-menu
    v-model="show"
    :style="`position: absolute; left: ${xTranslated}px; top: ${yTranslated}px`"
    absolute
    location="top"
  >
    <v-list>
      <v-list-item v-if="addButton" density="compact" @click="$emit('add')" prepend-icon="mdi-plus">
        <v-list-item-title>Add linked schematisation</v-list-item-title>
        <template #append>
          <v-tooltip left max-width="400">
            <template v-slot:activator="{ props }">
              <v-icon class="ml-3" small v-bind="props"> mdi-information </v-icon>
            </template>
            <span
              ><strong>Add linked schematisation </strong>will result in a new schematisation in
              which the schematisation stages marked as done are linked from the previous
              schematisation.</span
            >
          </v-tooltip>
        </template>
      </v-list-item>
      <v-list-item
        v-if="duplicateButton"
        density="compact"
        @click="$emit('duplicate')"
        prepend-icon="mdi-content-duplicate"
      >
        <v-list-item-title>Duplicate schematisation</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="navigateButton"
        density="compact"
        @click="$emit('navigate')"
        prepend-icon="mdi-navigation-variant-outline"
      >
        <v-list-item-title>Navigate to schematisation</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="exportFactSheetsButton"
        @click="$emit('export')"
        dense
        prepend-icon="mdi-export"
      >
        <v-list-item-title>Export fact sheets</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="exportDStabilityButton"
        @click="$emit('exportDStab')"
        dense
        prepend-icon="mdi-export"
      >
        <v-list-item-title>Export to D-Stability</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="exportJsonButton"
        @click="$emit('exportJson')"
        dense
        prepend-icon="mdi-export"
      >
        <v-list-item-title>Export JSON for POST</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="deleteButton"
        dense
        :disabled="deleteDisabled"
        @click="$emit('delete')"
        prepend-icon="mdi-delete"
      >
        <v-list-item-title>Delete</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: 'SchematisationActionMenu',
  props: {
    selectedItem: {},
    showMenu: {},
    addButton: { default: true, required: false },
    deleteButton: { default: true, required: false },
    deleteDisabled: { default: false, required: false },
    duplicateButton: { default: true, required: false },
    exportFactSheetsButton: { default: true, required: false },
    exportDStabilityButton: { default: true, required: false },
    exportJsonButton: { default: true, required: false },
    navigateButton: { default: true, required: false },
    x: {},
    y: {}
  },
  data() {
    return {
      width: 400,
      height: 300
    }
  },
  computed: {
    show: {
      get() {
        return this.showMenu
      },
      set(value) {
        this.$emit('update:showMenu', value)
      }
    },
    xTranslated() {
      return this.x - this.width
    },
    yTranslated() {
      return this.y - this.height / 2
    }
  }
}
</script>
